import { drugUploadActions } from '../../../../redux/actions/medication/drugs/drugs';

const initialState = {
  loading: false, // Indicates whether an upload is in progress
  data: null, // Holds the uploaded drug data if successful
  error: null // Stores error information if upload fails
};

/**
 * Reducer for managing drug upload actions.
 * @param {Object} state - Current state of the reducer.
 * @param {Object} action - Dispatched action containing type and payload.
 * @returns {Object} - New state based on action type.
 */
const drugUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case drugUploadActions.UPLOAD_DRUG.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case drugUploadActions.UPLOAD_DRUG.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload
      };

    case drugUploadActions.UPLOAD_DRUG.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return state; // Return current state for unhandled action types
  }
};

export default drugUploadReducer;
